import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatchService } from '../match.service';
import { ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-fancy-activities',
  templateUrl: './fancy-activities.component.html',
  styleUrls: ['./fancy-activities.component.css']
})
export class FancyActivitiesComponent implements OnInit {
  fancyActivities: any;
  isLoading = false;
  id: any;
  sel: any;
  private activitiesSub: Subscription;
  constructor(private matchService: MatchService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.isLoading = true;
    this.route.paramMap.subscribe((paramMap: ParamMap) => {     
      if (paramMap.has('id') && paramMap.has('sel')) {
        this.id = paramMap.get('id');
        this.sel = paramMap.get('sel');
        this.matchService.getFancyActivities(this.id, this.sel);
        this.activitiesSub = this.matchService.getUpdateFancyActivitiesListner()
        .subscribe((response) => {
          this.isLoading = false;
          this.fancyActivities = response.fancyActivities;
          console.log(this.fancyActivities);
        },
        error => {
          console.log(error);
        });
      } 
   });
  }

  ngOnDestroy() {
    this.activitiesSub.unsubscribe();
  }

}